// Toutes les images sont hébergées localement (règle permanente : aucune
// ressource externe, seule exception Google Analytics). Les photos Wikimedia
// Commons indiquent leur crédit + licence + lien (credit / creditUrl).
export const IMAGES = {
  hero: {
    src: "/images/penseur-rodin-jardin-musee-rodin.webp",
    alt: "Le Penseur d'Auguste Rodin, bronze monumental dans le jardin du musée Rodin à Paris",
    caption: "Fig. 01 — Le Penseur de Rodin, jardin du musée Rodin",
    credit: "Photo : Douglas O'Brien, CC BY-SA 2.0, image recadrée, via Wikimedia Commons",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Le_Penseur_in_the_Jardin_du_Mus%C3%A9e_Rodin,_Paris_14_June_2015.jpg",
  },
  figurative: {
    src: "/images/maillol-la-mediterranee-louvre.webp",
    alt: "La Méditerranée d'Aristide Maillol, sculpture figurative en bronze dans les jardins du Louvre",
    caption: "Fig. 02 — La Méditerranée de Maillol, jardins du Louvre",
    credit: "Photo : Shonagon, CC0, via Wikimedia Commons",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:La_M%C3%A9diterran%C3%A9e_-_Aristide_Maillol_-_Mus%C3%A9e_du_Louvre_Sculptures_des_jardins_FNAC_9492_-_TU_254.jpg",
  },
  studio: {
    src: "/images/atelier-sculpteur-modelage.webp",
    alt: "Mains d'un sculpteur taillant un buste blanc sur son socle, geste de l'atelier",
    caption: "Fig. 04 — Le geste de l'atelier",
  },
  marble: {
    src: "/images/buste-marbre-ptolemee-louvre.webp",
    alt: "Buste de Ptolémée de Maurétanie, sculpture en marbre de l'époque romaine, musée du Louvre",
    caption: "Fig. 05 — Buste en marbre de Ptolémée de Maurétanie, Louvre",
    credit: "Photo : Marie-Lan Nguyen, domaine public, image recadrée, via Wikimedia Commons",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Ptolemy_of_Mauretania_Louvre_Ma1887.jpg",
  },
  plaster: {
    src: "/images/platre-torse-aile.jpg",
    alt: "Torse ailé en plâtre blanc, épreuve d'atelier au rendu mat",
    caption: "Fig. — Épreuve de plâtre : le blanc mat de l'atelier",
  },
  clay: {
    src: "/images/danseuse-voilee-terre-cuite-louvre.webp",
    alt: "Danseuse voilée, figurine en terre cuite de la Grèce antique, musée du Louvre",
    caption: "Fig. 06 — Danseuse voilée, terre cuite grecque, Louvre",
    credit: "Photo : Marie-Lan Nguyen, domaine public, via Wikimedia Commons",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Veiled_dancer_Louvre_Myr660.jpg",
  },
  gallery: {
    src: "/images/galerie-visiteurs-oeuvres.webp",
    alt: "Visiteurs contemplant des œuvres sculpturales dans une galerie",
    caption: "Fig. 07 — L'œuvre et son public",
  },
  museum: {
    src: "/images/musee-interieur-expo.webp",
    alt: "Intérieur épuré d'un musée d'art contemporain",
    caption: "Fig. 08 — Nef d'un musée contemporain",
  },
  abstractMetal: {
    src: "/images/duchamp-villon-le-cheval-majeur.webp",
    alt: "Le Cheval majeur de Raymond Duchamp-Villon, sculpture abstraite en bronze de 1914",
    caption: "Fig. — Le Cheval majeur de Duchamp-Villon (1914)",
    credit: "Photo : domaine public, image recadrée, via Wikimedia Commons",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Duchamp-Villon_Cheval_majeur_Nasher_Dallas.jpg",
  },
  popDog: {
    src: "/images/pigments-poudres-couleurs.webp",
    alt: "Tas de pigments colorés en poudre : la couleur pure, matière première de la pop sculpture",
    caption: "Fig. — Pigments purs : la couleur en poudre",
    credit: "Photo : Kamalakanta777, CC BY-SA 3.0, image recadrée, via Wikimedia Commons",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Holi_shop.jpg",
  },
  graffiti: {
    src: "/images/fontaine-wallace-paris.webp",
    alt: "Fontaine Wallace en fonte verte, sculpture urbaine du XIXe siècle dans une rue de Paris",
    caption: "Fig. — Fontaine Wallace : la sculpture dans la rue, Paris",
    credit: "Photo : David McSpadden, CC BY 2.0, image recadrée, via Wikimedia Commons",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Sir_Richard_Wallace_drinking_fountain,_Paris_May_2014.jpg",
  },
  retiro: {
    src: "/images/lion-de-belfort-bartholdi.webp",
    alt: "Le Lion de Belfort d'Auguste Bartholdi, sculpture monumentale en grès de 22 mètres de long",
    caption: "Fig. — Le Lion de Belfort de Bartholdi : 22 mètres de grès",
    credit: "Photo : Thomas Bresson, CC BY 3.0, image recadrée, via Wikimedia Commons",
    creditUrl: "https://commons.wikimedia.org/wiki/File:2014-09-15_16-14-55_lion-belfort.jpg",
  },
  panels: {
    src: "/images/fourth-plinth-vide-trafalgar-square.webp",
    alt: "Le socle vide du Fourth Plinth sur Trafalgar Square, en attente de sa prochaine œuvre",
    caption: "Fig. — Le Fourth Plinth vide, Trafalgar Square : l'attente comme concept",
    credit: "Photo : Matt Brown, CC BY 2.0, image recadrée, via Wikimedia Commons",
    creditUrl: "https://commons.wikimedia.org/wiki/File:Empty_Fourth_Plinth.jpg",
  },
  foundry: {
    src: "/images/illu/diderot-fonte-atelier.webp",
    alt: "Coulée du métal : l'atelier de la fonderie d'une statue équestre avec son four, planche de l'Encyclopédie de Diderot et d'Alembert",
    caption: "Fig. 01 — L'atelier de la fonderie et le four de coulée, planche de l'Encyclopédie de Diderot et d'Alembert",
  },
  welding: {
    src: "/images/atelier-soudure-metal.webp",
    alt: "Soudeur au travail dans un atelier métal, étincelles volantes",
    caption: "Fig. 03 — Soudure de l'acier à l'atelier",
  },
  chisel: {
    src: "/images/taille-directe-ciseau-bois.webp",
    alt: "Ciseau à bois en action, copeaux de taille directe",
    caption: "Fig. 06 — Taille directe : le ciseau et le bois",
  },
  resinArt: {
    src: "/images/ambre-resine-naturelle-fossile.webp",
    alt: "Bloc d'ambre jaune translucide : une résine naturelle fossile, ancêtre des résines utilisées en sculpture",
    caption: "Fig. 02 — L'ambre, résine naturelle fossile, ancêtre des résines de sculpture",
    credit: "Photo : Rhetos, CC0, via Wikimedia Commons",
    creditUrl: "https://commons.wikimedia.org/wiki/File:B%C3%B6rnstein.jpg",
  },
  terreCuite: {
    src: "/images/tanagra-figurines-terre-cuite.webp",
    alt: "Sculptures en terre cuite : trois figurines dites de Tanagra, Grèce antique, IIIe siècle av. J.-C.",
    caption: "Figurines dites « de Tanagra », terre cuite, Grèce, IIIe siècle av. J.-C.",
    credit: "Photo : Giraudon, CC0, via Wikimedia Commons",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Greece_from_the_Coming_of_the_Hellenes_to_AD._14,_page_265,_Tanagra_figurines.jpg",
  },
  atelierAnonyme: {
    src: "/images/atelier-moulage-platres-bruxelles.webp",
    alt: "Atelier de moulage : plâtres en cours, moules et outils sur les établis, sans personnage",
    caption: "Fig. 09 — L'atelier de moulage : plâtres en cours, outils et établi",
    credit: "Photo : Sam Donvil, CC BY-SA 4.0, via Wikimedia Commons",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Magazijn_afgietselwerkplaats_KMKG_5.jpg",
  },
  figuratifMaillol: {
    src: "/images/maillol-la-montagne-bronze.webp",
    alt: "La Montagne d'Aristide Maillol, sculpture figurative en bronze de 1937, figure féminine allongée",
    caption: "La Montagne d'Aristide Maillol, bronze, 1937",
    credit: "Photo : Sdegroisse, CC BY-SA 4.0, via Wikimedia Commons",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Maillol-Aristide_la-montagne-1937-bronze.jpg",
  },
  abstractionCycladique: {
    src: "/images/idoles-cycladiques-nama.webp",
    alt: "Idoles cycladiques en marbre, figurines schématiques du IIIe millénaire av. J.-C., musée national archéologique d'Athènes",
    caption: "Idoles cycladiques, IIIe millénaire av. J.-C. : l'abstraction avant la lettre",
    credit: "Photo : Zde, CC BY-SA 4.0, via Wikimedia Commons",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Cycladic_figurines,_marble,_necklace,_silver,_2800-2700_BC,_NAMA,_190967.jpg",
  },
  oeuvreExposee: {
    src: "/images/glyptotheque-galerie-sculptures.webp",
    alt: "Galerie de statues antiques à la Glyptothèque Ny Carlsberg de Copenhague",
    caption: "Galerie de la Glyptothèque Ny Carlsberg, Copenhague",
    credit: "Photo : Daderot, CC0, via Wikimedia Commons",
    creditUrl:
      "https://commons.wikimedia.org/wiki/File:Danish_sculpture_gallery_-_Ny_Carlsberg_Glyptotek_-_Copenhagen_-_DSC09538.JPG",
  },
  visitorMuseum: {
    src: "/images/musee-sculptures-anciennes-visiteur.webp",
    alt: "Visiteur admirant des sculptures anciennes dans un musée",
    caption: "Fig. 13 — Le musée, lieu de la sculpture",
  },
};
